import { TwoWaySchedulePage } from './TwoWaySchedulePage';
export default TwoWaySchedulePage;
